import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request interceptor to add auth token
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor to handle errors
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.message === 'Network Error' || error.code === 'ERR_NETWORK') {
            // Auto-switch to offline mode
            window.dispatchEvent(new Event('offline'));
        }

        if (error.response?.status === 401) {
            // Don't redirect on login/register requests - let the component handle the error
            const requestUrl = error.config?.url || '';
            if (!requestUrl.includes('/auth/login') && !requestUrl.includes('/auth/register')) {
                // Token expired or invalid
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

export default api;
